/** @file bookings/blackouts.js — blackout CRUD. */
import { supabase } from "@/lib/supabaseClient";
import { nullEmpty } from "@/lib/constants";
import { composeInSiteTz, siteTz } from "@/lib/datetime";

export async function listBlackouts({ siteId = null, clientId = null } = {}) {
  let q = supabase
    .from("lbs_blackouts")
    .select(
      `id, client_id, site_id, bay_id, title, reason, start_time, end_time,
       is_full_day, created_by_role, created_at,
       site:lbs_sites!lbs_blackouts_site_id_fkey(name,code,timezone),
       bay:lbs_bays!lbs_blackouts_bay_id_fkey(name,code,color)`
    )
    .order("start_time", { ascending: true });
  if (siteId)   q = q.eq("site_id",   siteId);
  if (clientId) q = q.eq("client_id", clientId);
  return q;
}

const toUtc = (date, time, tz) => {
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute] = time.split(":").map(Number);
  return composeInSiteTz({ year, month, day, hour, minute }, tz);
};

async function buildBlackoutPayload(v) {
  const { data: site } = await supabase
    .from("lbs_sites")
    .select("client_id,timezone")
    .eq("id", v.site_id)
    .maybeSingle();
  const client_id = v.client_id || site?.client_id || null;
  const tz = siteTz(site);
  const start_time = toUtc(v.start_date, v.start_time, tz);
  const end_time = toUtc(v.end_date, v.end_time, tz);
  return nullEmpty({
    client_id,
    site_id: v.site_id,
    bay_id: v.bay_id || null,
    title: v.title,
    reason: v.reason,
    start_time,
    end_time,
    is_full_day: !!v.is_full_day,
  });
}

export async function createBlackout(values) {
  const payload = await buildBlackoutPayload(values);
  return supabase
    .from("lbs_blackouts")
    .insert(payload)
    .select()
    .maybeSingle();
}

export async function updateBlackout(id, values) {
  const payload = await buildBlackoutPayload(values);
  return supabase
    .from("lbs_blackouts")
    .update(payload)
    .eq("id", id)
    .select()
    .maybeSingle();
}

export async function deleteBlackout(id) {
  return supabase.from("lbs_blackouts").delete().eq("id", id).select();
}

/* =================  Incomplete-booking workflow (Phase γ) ============= */
